import { MaskLines, Reveal, Eyebrow } from "./Motion";
import { GlowOrb } from "./Glow";

const MARKETS = ["South Africa", "Nigeria", "Ghana", "Kenya", "Tanzania", "Rwanda", "Uganda"];

const Signal = () => (
  <div className="relative mx-auto aspect-square w-full max-w-[460px]" aria-hidden="true">
    {[0, 1.5, 3, 4.5].map((d) => (
      <span key={d} className="absolute inset-0 animate-ring rounded-full border border-pa-orange/60" style={{ animationDelay: `${d}s` }} />
    ))}
    {[0.35, 0.6, 0.85].map((s) => (
      <span key={s} className="absolute rounded-full border border-white/10" style={{ inset: `${(1 - s) * 50}%` }} />
    ))}
    <span className="absolute left-1/2 top-1/2 h-4 w-4 -translate-x-1/2 -translate-y-1/2 bg-pa-orange shadow-[0_0_30px_8px_rgba(242,101,49,0.7)]" />
    <span className="absolute left-1/2 top-1/2 mt-6 -translate-x-1/2 font-mono text-[10px] uppercase tracking-[0.25em] text-pa-muted">Africa</span>
    <span className="absolute right-[4%] top-[12%] font-mono text-[10px] uppercase tracking-[0.25em] text-pa-dim">World →</span>
  </div>
);

export const Global = () => (
  <section data-testid="global-section" className="grain relative overflow-hidden border-t border-white/10 bg-pa-black">
    <GlowOrb className="right-[5%] top-1/2 h-[560px] w-[560px] -translate-y-1/2" strength="md" />
    <div className="relative mx-auto grid max-w-[1400px] items-center gap-16 px-5 py-section-sm sm:px-8 lg:grid-cols-12 lg:px-12 lg:py-section">
      <div className="lg:col-span-7">
        <Reveal><Eyebrow>Africa + global / 05</Eyebrow></Reveal>
        <MaskLines
          lines={["Built for", "African creators.", <span className="text-outline">Built for</span>, <span className="text-glow text-pa-orange">the world.</span>]}
          label="Built for African creators. Built for the world."
          className="mt-6 font-display text-[clamp(3rem,8vw,7.5rem)] uppercase leading-[0.88] text-pa-ink"
        />
        <Reveal delay={0.2} className="mt-10 max-w-xl text-base leading-relaxed text-pa-muted md:text-lg">
          <p className="font-display text-3xl uppercase tracking-wide text-pa-ink">African music is global.</p>
          <p className="mt-4">Pitchally is built with African creators at the center, while connecting them to opportunities, audiences and markets beyond borders.</p>
        </Reveal>
        <Reveal delay={0.3}>
          <ul className="mt-10 flex flex-wrap gap-x-5 gap-y-2 font-mono text-[11px] uppercase tracking-[0.2em] text-pa-muted">
            {MARKETS.map((m) => <li key={m}>{m}</li>)}
            <li className="text-pa-orange-text">+ Beyond borders</li>
          </ul>
        </Reveal>
      </div>
      <div className="lg:col-span-5"><Signal /></div>
    </div>
  </section>
);
